import {
  ACCEPT_REJECT_DOMAIN,
  ACCEPT_REJECT_DOMAIN_FAILURE,
  ACCEPT_REJECT_DOMAIN_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  EDIT_INFLUENCER_USER,
  EDIT_INFLUENCER_USER_FAILURE,
  EDIT_INFLUENCER_USER_SUCCESS,
  GET_BLOOM_USER_LIST,
  GET_BLOOM_USER_LIST_FAILURE,
  GET_BLOOM_USER_LIST_SUCCESS,
  GET_BLOOMSUB_USER_LIST,
  GET_BLOOMSUB_USER_LIST_FAILURE,
  GET_BLOOMSUB_USER_LIST_SUCCESS,
  GET_DOMAIN_DETAILS,
  GET_DOMAIN_DETAILS_FAILURE,
  GET_DOMAIN_DETAILS_SUCCESS,
  GET_DOMAIN_INFO_LIST,
  GET_DOMAIN_INFO_LIST_FAILURE,
  GET_DOMAIN_INFO_LIST_SUCCESS,
  GET_DREAM_FAILURE,
  GET_DREAM_LIST,
  GET_DREAM_SUCCESS,
  GET_EDUCATION_FAILURE,
  GET_EDUCATION_LIST,
  GET_EDUCATION_SUCCESS,
  GET_ETHNICITY_FAILURE,
  GET_ETHNICITY_LIST,
  GET_ETHNICITY_SUCCESS,
  GET_FREE_USER_LIST,
  GET_FREE_USER_LIST_FAILURE,
  GET_FREE_USER_LIST_SUCCESS,
  GET_FREESUB_USER_LIST,
  GET_FREESUB_USER_LIST_FAILURE,
  GET_FREESUB_USER_LIST_SUCCESS,
  GET_HOBBIES_FAILURE,
  GET_HOBBIES_LIST,
  GET_HOBBIES_SUCCESS,
  GET_INTRESTED_FAILURE,
  GET_INTRESTED_LIST,
  GET_INTRESTED_SUCCESS,
  GET_INVITE_FRIENDS_LIST,
  GET_INVITE_FRIENDS_LIST_FAILURE,
  GET_INVITE_FRIENDS_LIST_SUCCESS,
  GET_MESSAGE_DETAILS,
  GET_MESSAGE_DETAILS_FAILURE,
  GET_MESSAGE_DETAILS_SUCCESS,
  GET_MESSAGE_LIST,
  GET_MESSAGE_LIST_FAILURE,
  GET_MESSAGE_LIST_SUCCESS,
  GET_MYSELF_FAILURE,
  GET_MYSELF_LIST,
  GET_MYSELF_SUCCESS,
  GET_PREMIUM_USER_LIST,
  GET_PREMIUM_USER_LIST_FAILURE,
  GET_PREMIUM_USER_LIST_SUCCESS,
  GET_PREMIUMSUB_USER_LIST,
  GET_PREMIUMSUB_USER_LIST_FAILURE,
  GET_PREMIUMSUB_USER_LIST_SUCCESS,
  GET_QUERY_DETAILS,
  GET_QUERY_DETAILS_FAILURE,
  GET_QUERY_DETAILS_SUCCESS,
  GET_QUERY_USER_LIST,
  GET_QUERY_USER_LIST_FAILURE,
  GET_QUERY_USER_LIST_SUCCESS,
  GET_RELATION_FAILURE,
  GET_RELATION_LIST,
  GET_RELATION_SUCCESS,
  GET_RELIGION_FAILURE,
  GET_RELIGION_LIST,
  GET_RELIGION_SUCCESS,
  GET_SUB_USER_LIST,
  GET_SUB_USER_LIST_FAILURE,
  GET_SUB_USER_LIST_SUCCESS,
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTION_DETAILS_FAILURE,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FAILURE,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_LIST,
  GET_USER_LIST_FAILURE,
  GET_USER_LIST_SUCCESS,
  GET_USERS_FEEDBACK_LIST,
  GET_USERS_FEEDBACK_LIST_FAILURE,
  GET_USERS_FEEDBACK_LIST_SUCCESS,
  OPEN_CLOSE_SUPPORT,
  OPEN_CLOSE_SUPPORT_FAILURE,
  OPEN_CLOSE_SUPPORT_SUCCESS,
  RESUME_SUSPEND_USER,
  RESUME_SUSPEND_USER_FAILURE,
  RESUME_SUSPEND_USER_SUCCESS,
  SEND_ADMIN_MESSAGE_RESPONSE,
  SEND_ADMIN_MESSAGE_RESPONSE_FAILURE,
  SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS,
  SEND_ADMIN_QUERY_RESPONSE,
  SEND_ADMIN_QUERY_RESPONSE_FAILURE,
  SEND_ADMIN_QUERY_RESPONSE_SUCCESS,
} from '../Actiontype';

const initialState = {
  isFetching: false,
  UserListSuccess: false,
  UserListSuccessMessage: '',
  UserListFailure: false,
  UserListFailureMessage: '',
  UserListData: null,
  DeleteSuccess: false,
  DeleteSuccessMessage: '',
  DeleteFailure: false,
  DeleteFailureMessage: '',
  UserDetails: null,
  SubscribedData: '',
  SubUserListData: null,
  QueryUserListData: null,
  EthnicityListData: null,
  AcceptRejectDomainSuccess: false,
  AcceptRejectDomainSuccessMessage: '',
  AcceptRejectDomainFailure: false,
  AcceptRejectDomainFailureMessage: '',
  ReligionListData: null,
  ImportanceReligionListData: null,
  DreamListData: null,
  DreamPartnerListData: null,
  ResumeSuspendUserSuccess: false,
  ResumeSuspendUserSuccessMessage: '',
  ResumeSuspendUserFailure: false,
  ResumeSuspendUserFailureMessage: '',
  QueryDetailsData: null,
  OpenCloseSupportSuccess: false,
  OpenCloseSupportSuccessMessage: '',
  OpenCloseSupportFailure: false,
  OpenCloseSupportFailureMessage: '',
  DomainDetails: null,
  EditInfluencerUserSuccess: false,
  EditInfluencerUserSuccessMessage: '',
  EditInfluencerUserFailure: false,
  EditInfluencerUserFailureMessage: '',
  UsersFeedbackListSuccess: false,
  UsersFeedbackListSuccessMessage: '',
  UsersFeedbackListFailure: false,
  UsersFeedbackListFailureMessage: '',
  UsersFeedbackListData: null,
  InviteFriendsListData: null,
  InviteFriendsListFailure: false,
  InviteFriendsListFailureMessage: '',
  InviteFriendsListSuccess: false,
  InviteFriendsListSuccessMessage: '',
};
export default function DashBoardReducer(state = initialState, action) {
  // console.log("actionaction",action)
  switch (action.type) {
    case GET_FREESUB_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_FREESUB_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_FREESUB_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };
    case GET_FREE_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_FREE_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_FREE_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };
    case GET_BLOOMSUB_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_BLOOMSUB_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_BLOOMSUB_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };

    case GET_BLOOM_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryUserListData: null,
      };
    case GET_BLOOM_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryUserListData: action.payload,
      };
    case GET_BLOOM_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryUserListData: null,
      };

    case GET_PREMIUMSUB_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_PREMIUMSUB_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_PREMIUMSUB_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };

    case GET_PREMIUM_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryUserListData: null,
      };
    case GET_PREMIUM_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryUserListData: action.payload,
        count: action.count,
        totalAmount: action.totalAmount,
      };
    case GET_PREMIUM_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryUserListData: null,
      };

    case GET_ETHNICITY_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        EthnicityListData: null,
      };
    case GET_ETHNICITY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        EthnicityListData: action.payload,
      };
    case GET_ETHNICITY_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        EthnicityListData: null,
      };
    case GET_QUERY_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryUserListData: null,
      };
    case GET_QUERY_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryUserListData: action.payload,
      };
    case GET_QUERY_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryUserListData: null,
      };

    case GET_QUERY_DETAILS:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryDetailsData: null,
      };
    case GET_QUERY_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryDetailsData: action.payload,
      };
    case GET_QUERY_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryDetailsData: null,
      };

    case GET_MESSAGE_DETAILS:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryDetailsData: null,
      };
    case GET_MESSAGE_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryDetailsData: action.payload,
      };
    case GET_MESSAGE_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryDetailsData: null,
      };

    case SEND_ADMIN_QUERY_RESPONSE:
      return {
        ...state,
        isFetching: true,
        SendAdminQueryResponseSuccess: false,
        SendAdminQueryResponseSuccessMessage: '',
        SendAdminQueryResponseFailure: false,
        SendAdminQueryResponseFailureMessage: '',
        QueryDetailsData: null,
      };
    case SEND_ADMIN_QUERY_RESPONSE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        SendAdminQueryResponseSuccess: true,
        SendAdminQueryResponseSuccessMessage: action.payload.message,
        QueryDetailsData: action.payload,
      };
    case SEND_ADMIN_QUERY_RESPONSE_FAILURE:
      return {
        ...state,
        isFetching: false,
        SendAdminQueryResponseFailure: true,
        SendAdminQueryResponseFailureMessage: action.payload.message,
        QueryDetailsData: null,
      };

    case SEND_ADMIN_MESSAGE_RESPONSE:
      return {
        ...state,
        isFetching: true,
        SendAdminQueryResponseSuccess: false,
        SendAdminQueryResponseSuccessMessage: '',
        SendAdminQueryResponseFailure: false,
        SendAdminQueryResponseFailureMessage: '',
        QueryDetailsData: null,
      };
    case SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        SendAdminQueryResponseSuccess: true,
        SendAdminQueryResponseSuccessMessage: action.payload.message,
        QueryDetailsData: action.payload,
      };
    case SEND_ADMIN_MESSAGE_RESPONSE_FAILURE:
      return {
        ...state,
        isFetching: false,
        SendAdminQueryResponseFailure: true,
        SendAdminQueryResponseFailureMessage: action.payload.message,
        QueryDetailsData: null,
      };

    case GET_MESSAGE_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        QueryUserListData: null,
      };
    case GET_MESSAGE_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        QueryUserListData: action.payload,
      };
    case GET_MESSAGE_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        QueryUserListData: null,
      };

    case GET_RELIGION_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        ReligionListData: null,
        ImportanceReligionListData: null,
      };
    case GET_RELIGION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        ReligionListData: action.payload.filter(data => data.type === 'religion'),
        ImportanceReligionListData: action.payload.filter(data => data.type === 'religion_importance'),
      };
    case GET_RELIGION_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        ReligionListData: null,
        ImportanceReligionListData: null,
      };
    case GET_EDUCATION_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_EDUCATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_EDUCATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: null,
      };

    case GET_MYSELF_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_MYSELF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_MYSELF_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: null,
      };

    case GET_HOBBIES_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_HOBBIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_HOBBIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: null,
      };

    case GET_INTRESTED_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_INTRESTED_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_INTRESTED_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: null,
      };

    case GET_RELATION_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_RELATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_RELATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: null,
      };
    case GET_DREAM_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        DreamListData: null,
        DreamPartnerListData: null,
      };
    case GET_DREAM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        DreamListData: action.payload.filter(data => data.type === 'mydream'),
        DreamPartnerListData: action.payload.filter(data => data.type === 'patner_mydream'),
      };
    case GET_DREAM_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        DreamListData: null,
        DreamPartnerListData: null,
      };
    case GET_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
        UserCount: action.userCount,
        filter: action.filter,
      };
    case GET_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };
    case GET_SUB_USER_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        SubUserListData: null,
      };
    case GET_SUB_USER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        SubUserListData: action.payload,
      };
    case GET_SUB_USER_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        SubUserListData: null,
      };
    case GET_USERS_FEEDBACK_LIST:
      return {
        ...state,
        isFetching: true,
        UsersFeedbackListSuccess: false,
        UsersFeedbackListSuccessMessage: '',
        UsersFeedbackListFailure: false,
        UsersFeedbackListFailureMessage: '',
        UsersFeedbackListData: null,
      };
    case GET_USERS_FEEDBACK_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UsersFeedbackListSuccess: true,
        UsersFeedbackListSuccessMessage: action.payload.message,
        UsersFeedbackListData: action.payload.ratings,
      };
    case GET_USERS_FEEDBACK_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UsersFeedbackListFailure: true,
        UsersFeedbackListFailureMessage: action.payload.message,
        UsersFeedbackListData: null,
      };
    case GET_INVITE_FRIENDS_LIST:
      return {
        ...state,
        isFetching: true,
        InviteFriendsListSuccess: false,
        InviteFriendsListSuccessMessage: '',
        InviteFriendsListFailure: false,
        InviteFriendsListFailureMessage: '',
        InviteFriendsListData: null,
      };
    case GET_INVITE_FRIENDS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        InviteFriendsListListSuccess: true,
        InviteFriendsListSuccessMessage: action.payload.message,
        InviteFriendsListData: action.payload.results,
      };
    case GET_INVITE_FRIENDS_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        InviteFriendsListFailure: true,
        InviteFriendsListFailureMessage: action.payload.message,
        InviteFriendsListData: null,
      };
    case GET_USER_DETAILS:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserDetails: null,
        SubscribedData: '',
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserDetails: action.payload,
      };
    case GET_USER_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserDetails: null,
      };
    case GET_SUBSCRIPTION_DETAILS:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        SubscribedData: '',
      };
    case GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        SubscribedData: action.payload,
      };
    case GET_SUBSCRIPTION_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        SubscribedData: '',
      };
    case DELETE_USER:
      return {
        ...state,
        isFetching: true,
        DeleteSuccess: false,
        DeleteSuccessMessage: '',
        DeleteFailure: false,
        DeleteFailureMessage: '',
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        DeleteSuccess: true,
        DeleteSuccessMessage: action.payload.message,
      };
    case DELETE_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        DeleteFailure: true,
        DeleteFailureMessage: action.payload.message,
      };
    case ACCEPT_REJECT_DOMAIN:
      return {
        ...state,
        isFetching: true,
        AcceptRejectDomainSuccess: false,
        AcceptRejectDomainSuccessMessage: '',
        AcceptRejectDomainFailure: false,
        AcceptRejectDomainFailureMessage: '',
      };
    case ACCEPT_REJECT_DOMAIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AcceptRejectDomainSuccess: true,
        AcceptRejectDomainSuccessMessage: action.payload.message,
      };
    case ACCEPT_REJECT_DOMAIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        AcceptRejectDomainFailure: true,
        AcceptRejectDomainFailureMessage: action.payload.message,
      };
    case RESUME_SUSPEND_USER:
      return {
        ...state,
        isFetching: true,
        ResumeSuspendUserSuccess: false,
        ResumeSuspendUserSuccessMessage: '',
        ResumeSuspendUserFailure: false,
        ResumeSuspendUserFailureMessage: '',
      };
    case RESUME_SUSPEND_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ResumeSuspendUserSuccess: true,
        ResumeSuspendUserSuccessMessage: action.payload.message,
      };
    case RESUME_SUSPEND_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        ResumeSuspendUserFailure: true,
        ResumeSuspendUserFailureMessage: action.payload.message,
      };
    case OPEN_CLOSE_SUPPORT:
      return {
        ...state,
        isFetching: true,
        OpenCloseSupportSuccess: false,
        OpenCloseSupportSuccessMessage: '',
        OpenCloseSupportFailure: false,
        OpenCloseSupportFailureMessage: '',
      };
    case OPEN_CLOSE_SUPPORT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        OpenCloseSupportSuccess: true,
        OpenCloseSupportSuccessMessage: action.payload.message,
      };
    case OPEN_CLOSE_SUPPORT_FAILURE:
      return {
        ...state,
        isFetching: false,
        OpenCloseSupportFailure: true,
        OpenCloseSupportFailureMessage: action.payload.message,
      };
    case GET_DOMAIN_INFO_LIST:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        UserListData: null,
      };
    case GET_DOMAIN_INFO_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        UserListData: action.payload,
      };
    case GET_DOMAIN_INFO_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        UserListData: [],
      };
    case GET_DOMAIN_DETAILS:
      return {
        ...state,
        isFetching: true,
        UserListSuccess: false,
        UserListSuccessMessage: '',
        UserListFailure: false,
        UserListFailureMessage: '',
        DomainDetails: null,
      };
    case GET_DOMAIN_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        UserListSuccess: true,
        UserListSuccessMessage: action.payload.message,
        DomainDetails: action.payload,
      };
    case GET_DOMAIN_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        UserListFailure: true,
        UserListFailureMessage: action.payload.message,
        DomainDetails: null,
      };
    case EDIT_INFLUENCER_USER:
      return {
        ...state,
        isFetching: true,
        EditInfluencerUserSuccess: false,
        EditInfluencerUserSuccessMessage: '',
        EditInfluencerUserFailure: false,
        EditInfluencerUserFailureMessage: '',
      };
    case EDIT_INFLUENCER_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        EditInfluencerUserSuccess: true,
        EditInfluencerUserSuccessMessage: action.payload.Message,
      };
    case EDIT_INFLUENCER_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        EditInfluencerUserFailure: true,
        EditInfluencerUserFailureMessage: action.payload.Message,
      };
    default:
      return {
        ...state,
      };
  }
}
